import React, { useEffect } from "react";
import { useBusinessContext } from "../../../../../context/business";
import Staff from "./Staff";
import logo from "./../../../../../assets/kindlybook-Icon-colored.png";
export default function StaffForm({ submitForm, currentStepIndex }) {
  const {
    businessData: { team, businessData },
    setSelectedBusiness,
  } = useBusinessContext();

  useEffect(() => {
    //  
    if (team?.length === 1 || (team && businessData && !businessData?.show_team_members)) {
       
       
      setSelectedBusiness({ type: "SELECT_STAFF", data: team[0] });
      submitForm();
    }

  }, [team]);

  const randomStaff = () => {
    const randomID = Math.round(Math.random() * (team?.length - 1));
    setSelectedBusiness({ type: "SELECT_STAFF", data: team[randomID] });
  };

  return (
    <form
      onSubmit={submitForm}
      className="step_container"
      data-is-active={(currentStepIndex === 1).toString()}
    >
      {team?.map((member, index) => (
        <Staff data={member} key={index} />
      ))}
      {team?.length > 1 && (
        <button
          onClick={randomStaff}
          className="card selectStaff flex"
        >
          <img src={logo} alt="" srcset="" className="profile_picture" />

          <div className="flex arrow_container">
            <div className="text_holder">
              <p className="name">No Preference</p>
            </div>
          </div>
        </button>
      )}
    </form>
  );
}
